const breakpoints = {
    isMobile() {
        return window.innerWidth <= 1200;
    },
};
export default breakpoints;
